import { useEffect, useState } from 'react';
import { dashboardsService } from '@/services/dashboards.service';
import { catalogoDaVisaoGeral, type CatalogoApontamento } from '@/utils/equiplexApontamentos';

/**
 * Meses, máquinas e SKUs do último retrato da Visão geral. Sem retrato (ou com erro), a
 * tela segue funcionando: `catalogo` fica `null` e máquina e SKU viram texto livre.
 */
export function useCatalogoApontamento(): { catalogo: CatalogoApontamento | null; carregando: boolean } {
  const [catalogo, setCatalogo] = useState<CatalogoApontamento | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let vivo = true;
    dashboardsService
      .getEquiplexVisaoGeral()
      .then((r) => {
        if (vivo && r.snapshot) setCatalogo(catalogoDaVisaoGeral(r.snapshot.payload));
      })
      .catch(() => undefined)
      .finally(() => {
        if (vivo) setCarregando(false);
      });
    return () => {
      vivo = false;
    };
  }, []);

  return { catalogo, carregando };
}
